<template>
  <div id="container">
    <slot/>
  </div>
</template>

<script>
/*
The displaying of the globe was mostly taken from the following gist
https://gist.github.com/mbostock/2b85250396c17a79155302f91ec21224
 */

import Globe from './globe';
import actions from '../../store/actions';

// --------------------
export default {
  name: 'Globe',
  mounted() {
    const x = new Globe();
    x.init();
    this.$store.dispatch(actions.CHANGE_SET_CANVAS_ENABLED_CALLBACK, x.setEnabled.bind(x));
    this.$store.dispatch(actions.CHANGE_SET_GLOBE_AUTOROTATION_CALLBACK, x.setAutorotation.bind(x));
  },
};
</script>

<style scoped>
  #container {
    width: 100vw;
    height: calc(100vh - 3.25rem);
  }
</style>

<style>
  canvas {
    outline: none;
  }
</style>
